import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateListSearch } from '@/shared/lib/listSearch';

/**
 * `/billing` is deliberately NOT a settings tab: it is the one screen the app
 * shell's subscription gate (app/routes/roots.tsx) lets a blocked agency
 * reach, so it needs an address of its own. The list params are the invoices
 * table's.
 */
export const billingRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/billing',
  component: lazyRouteComponent(() => import('./pages/BillingPage'), 'BillingPage'),
  validateSearch: validateListSearch,
});

export const billingRoutes = [billingRoute];
